import useSWRImmutable from 'swr/immutable';

import { PVSUserRoleMapping } from '@/models/pvs/UserRoleMapping.ts';

import { getMappedPVSUsers } from '@/services/authService.ts';

import { useAuthStore } from '@/stores/authStore.ts';

interface PvsUserRolesHook {
    pvs_user_roles: PVSUserRoleMapping[];
    is_loading: boolean;
}

export const usePvsUserRoles = (): PvsUserRolesHook => {
    const user_email = useAuthStore((state) => state.user_email);

    const { data: pvs_user_roles, isLoading: is_loading } = useSWRImmutable(
        user_email ? `pvs-user-roles-${user_email}` : undefined,
        getMappedPVSUsers,
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
        }
    );
    return { pvs_user_roles: pvs_user_roles ?? [], is_loading: is_loading };
};
